import {
  DEPOSIT_LIST,
  DEPOSIT_LIST_SUCCESS,
  DEPOSIT_LIST_FAILURE,
} from "../actionTypes";

export const depositList = (payload) => ({
  type: DEPOSIT_LIST,
  payload,
});

export const depositListSuccess = (payload) => ({
  type: DEPOSIT_LIST_SUCCESS,
  payload,
});

export const depositListFailure = () => ({
  type: DEPOSIT_LIST_FAILURE,
});
